import { format as formatDate } from 'date-fns';

export class FormatHelper {
    static formatDate(dateAsUtcString: string, format: string = 'DD-MMM-YYYY h:mmA'): string {
        return dateAsUtcString ? formatDate(dateAsUtcString, format) : '';
    }
}
